import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import Button_v2 from "../../stories/components/Button_v2";
import Select_v2 from "../../stories/components/Select_v2";
import Modal_v2 from "../../stories/components/Modal_v2";
import I18n from "../../common/I18n";


const LosUpdate = ({openModal, setOpenModal, orderDetails, levelOfServices, form, handleSave}) => {

const [formValues, setFormValues] = useState({})
const { getFieldDecorator } = form;

const validateForm = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          handleSave(formValues)
        }
    });
    }
const handleChange = (los_id, loc_id) => {
    setFormValues({
        ...formValues,
        [loc_id]: los_id

    })
}
  const modalContent = () => {
    const isRequired = true;
    return (
      <div>
        <p className="modal-text">
          You made changes to the {I18n.t('general.warehouse_small')} or account requiring an update to
          the service level.
        </p>
        <Form colon={false}>
          <Row gutter={8}>
            {
              orderDetails?.locations?.map(loc => ( <Col span={12} key={`${loc.id}_los_update`}>
                <Form.Item
                    label={`${loc.type_of_loc} ${I18n.t("general.level_of_service")}`}
                    className={ isRequired ? "required-star-right" : ""}
                    name="los_code"
                    key={`${loc.id}_los_code`}
                >
                    {getFieldDecorator(`${loc.id}_los_code`, {
                        rules: [
                            { required: isRequired, message: `Please select ${I18n.t("general.level_of_service_small")}` },
                        ],
                    })(
                        <Select_v2
                            labelField="name"
                            valueField="code"
                            onChange={(value) => handleChange(value, loc.id)}
                            options={[...levelOfServices]}
                            placeholder="--Select--"
                            showSelectOption={true}
                           // value={location?.los_code}
                        />
                    )}
                </Form.Item>
              </Col>))
            }
          </Row>
        </Form>
      </div>
    );
  };

  const modalFooter = () => {
    return (
      <div>
        <Button_v2
          onClick={() => setOpenModal(false)}
          className="flat medium-btn"
          text="Cancel"
        />
        <Button_v2
          onClick={validateForm}
          className="raised medium-btn"
          text="Save Changes"
        />
      </div>
    );
  };
  return (
    <div className="service-level-update">
      <Modal_v2
        className="service-level-modal"
        visible={openModal}
        title="Service Level"
        content={modalContent()}
        footer={modalFooter()}
        width={524}
        closable={false}
      />
    </div>
  );
};

export default Form.create()(LosUpdate);
